// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"6d72cf03","693":"28e7bc39","845":"0b7b10ee"}[chunkId] + ".chunk.js";
};